import React from 'react'

export function Example({ example, id }) {
  return (
    <>
      <h3 id={id}>{example.title}</h3>
      <pre className={example.type}>{example.content}</pre>
    </>
  )
}
